import React from 'react';
import { Breakpoint } from '@moda/om';
import { OrderDetailsDesktop } from './OrderDetailsDesktop';
import { OrderDetailsMobile } from './OrderDetailsMobile';

export const OrderDetails: React.FC = () => (
  <>
    <Breakpoint gt="md">
      <OrderDetailsDesktop />
    </Breakpoint>
    <Breakpoint lt="md">
      <OrderDetailsMobile />
    </Breakpoint>
  </>
);
